import { TabsComponent } from './tabs/tabs.component';
import { TabComponent } from './tab/tab.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

const components = [TabsComponent, TabComponent];
@NgModule({
  imports: [CommonModule],
  declarations: [...components],
  exports: [...components],
})
export class TabsComponentsModule {}
